/**
 * 사이드바 글쓰기 버튼 컴포넌트
 */ import React from 'react';
import * as m from "@paraglide/messages";
import { Pen as PenLine } from 'lucide-react';
import { TWEET_COMPOSER_TEST_IDS } from '@edusense/shared-constants';
export const WriteButton = ({ showWriteButton, onWriteButtonClick, isTabletView, isMobileSidebar, isIconOnlyMode })=>{
    if (!showWriteButton || !onWriteButtonClick) {
        return null;
    }
    const shouldUseIconOnly = typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, shouldUseIconOnly ? // 태블릿 뷰 - 아이콘만 표시
    /*#__PURE__*/ React.createElement("button", {
        "data-testid": TWEET_COMPOSER_TEST_IDS.COMPOSE_TRIGGER,
        onClick: onWriteButtonClick,
        title: m.common_edit(),
        style: {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0.75rem',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
            backgroundColor: '#6366f1',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            position: 'relative'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.backgroundColor = '#4f46e5';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.backgroundColor = '#6366f1';
        }
    }, /*#__PURE__*/ React.createElement(PenLine, {
        size: 20
    })) : // 데스크톱 뷰 - 전체 버튼
    /*#__PURE__*/ React.createElement("button", {
        "data-testid": TWEET_COMPOSER_TEST_IDS.COMPOSE_TRIGGER,
        onClick: onWriteButtonClick,
        style: {
            width: isMobileSidebar ? '100%' : 'auto',
            minWidth: '200px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: isMobileSidebar ? 'flex-start' : 'flex-end',
            gap: '0.75rem',
            padding: '0.75rem 1rem',
            marginTop: '0.5rem',
            marginBottom: '0.5rem',
            backgroundColor: '#6366f1',
            color: 'white',
            border: 'none',
            borderRadius: '0.5rem',
            fontSize: '0.875rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: '0 2px 4px rgba(99, 102, 241, 0.2)'
        },
        onMouseEnter: (e)=>{
            e.currentTarget.style.backgroundColor = '#4f46e5';
            e.currentTarget.style.boxShadow = '0 4px 8px rgba(99, 102, 241, 0.3)';
        },
        onMouseLeave: (e)=>{
            e.currentTarget.style.backgroundColor = '#6366f1';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(99, 102, 241, 0.2)';
        }
    }, isMobileSidebar && /*#__PURE__*/ React.createElement(PenLine, {
        size: 20
    }), m.common_edit(), !isMobileSidebar && /*#__PURE__*/ React.createElement(PenLine, {
        size: 20
    })));
};
